// domain/entities/remark.ts
export class RemarkData {
  constructor(
    public readonly id: number,
    public readonly code: string,
    public readonly provider_id: number,
    public readonly provider_tier: string,
    public readonly description: string,
    public readonly provider: string,
    public readonly line: string,
    public readonly issueReason: string,
    public readonly actions: string,
    public readonly impactPercentage: number,
    public readonly logisticsFlow: string,
    public readonly reportDate: string,
    public readonly createdAt: string | null,
    public readonly modifiedAt: string | null
  ) {}
}
